import { Component, HostBinding } from '@angular/core';
import { IHeaderAngularComp } from 'ag-grid-angular';
import { IHeaderParams } from 'ag-grid-community';
import { AppService } from 'src/app/app.service';

@Component({
  selector: 'app-invite-link-header-renderer',
  imports: [],
  templateUrl: './invite-link-header-renderer.component.html',
  styleUrl: './invite-link-header-renderer.component.scss',
})
export class InviteLinkHeaderRendererComponent implements IHeaderAngularComp {
  @HostBinding('class') className = 'ag-header-cell-text';
  params: IHeaderParams;
  checked: boolean = false;

  headerName: string = 'Access Code';
  headerField: string = 'accessCode';

  constructor(private _appService: AppService) {
    if (this._appService.team.isElevateTeam) {
      this.headerName = 'Invite Link';
      this.headerField = 'inviteLink';
    }
  }

  agInit(params: IHeaderParams): void {
    this.params = params;

    // Change the header name and field to "Invite Link" and "inviteLink" respectively
    this.params.column.getColDef().headerName = this.headerName;
    this.params.column.getColDef().field = this.headerField;
  }

  refresh(): boolean {
    return false;
  }
}
